RivalIQ.apps.Insights.module('widgets.media', function (media, App, Backbone, Marionette, $, _) {

    'use strict';

    media.MediaLoadErrorHandler = {
        onLoadDataError: function (results) {
            const me = this;

            if (results) {
                if (_.get(results, ['error', 'errorName']) === 'NotAuthorizedError') {

                    const elementName = (me.dashboardModel.getProp('objectType') === RivalIQ.enums.insightsObjectType.post ? 'posts' : 'stories');
                    me._parentLoadingView.loadingView.showError('grid-view-empty', '#insightsCustomDashboardsNoFocusCompanyTemplate', {
                        elementName: _.upperFirst(elementName),
                        sourceName: _.get(RivalIQ.enums.sourceDetails, [me.dashboardModel.getProp('source'), 'name'])
                    });

                    // If we're exporting, let the export complete with the "not auth" view in place.
                    if (me.dashboardModel.isExporting()) {
                        me.requestFrame(function () {
                            me._onRenderFinished();
                        });
                    }

                } else {
                    me._parentLoadingView.loadingView.showError('widget-error', '#widgetErrorView');

                    // Only fail the export is this is not an auth error.
                    if (me.dashboardModel.isExporting()) {
                        RivalIQ.export.failExport(_.get(results, ['responseJSON', 'error', 'message'], results));
                    }
                }
            }
        }
    };
});
